<template>
  <router-link :id="$attrs['id']"
               :to="{ name: link, params: params }"
               tag="li"
               active-class="item-nav__li--active"
               class="item-nav__li"
               exact>
    <span :class="['item-nav__link__label', `item-nav__link__label--level-${level}`]"
          @dragover="$emit('dragover', $event)"
          @dragenter="$emit('dragenter', $event)"
          @dragleave="$emit('dragleave', $event)"
          @drop="$emit('drop', $event)">- &nbsp; <slot name="label">{{ label }}</slot><div v-if="beta" class="item-nav__item__badge">{{ $t('betaVersion.title') }}</div></span>
  </router-link>
</template>

<script>

import CardBadge from '../CardBadge';

export default {
  name: 'ItemNavGroupItem',
  components: { CardBadge },
  props: ['link', 'label', 'params', 'level', 'beta'],

  data() {
    return { };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
  @import '~styles/components/lib/ItemNav';

  .item-nav__li span.item-nav__link__label {
    &--level-1, &--level-undefined {
      padding-left: 2rem;
    }
    &--level-2 {
      padding-left: 4rem;
    }
    &--level-3 {
      padding-left: 6rem;
    }
    &--level-4 {
      padding-left: 8rem;
    }
  }

  .item-nav__item__badge {
    background-color: $mint;
    position: absolute;
    line-height: 1;
    top: 10px;
    right: 16px;
    padding: 8px 16px;
    border-radius: 16px;
    color: white;
    font-weight: bold;
    white-space: nowrap;
    transform: rotate(0deg);
  }

</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/ItemNavGroupItem.vue